<div *ngrxLet="formControl.touched && formControl.invalid as invalid">
  <div
    class="confirmation-box-type__container py-2 pe-2"
    [ngClass]="{
      'zone-dark': !!props.options,
      'confirmation-box-type__container--multi': !!props.options,
      'confirmation-box-type__container--invalid': invalid,
      'confirmation-box-type__container--required': props.required
    }"
  >
    <div class="confirmation-box-type__field position-relative">
      <mat-checkbox
        *ngIf="!props.options; else multiOptionTmpl"
        [formControl]="formControl"
        [id]="id"
        [formlyAttributes]="field"
        [required]="$any(props.required)"
        [tabIndex]="props.tabindex"
        [color]="props.color"
        [class.mat-mdc-checkbox-readonly]="props.readonly"
      >
        <div
          class="confirmation-box-type__label"
          [innerHTML]="props.label"
        ></div>
      </mat-checkbox>
    </div>
    <mat-error *ngIf="invalid" class="confirmation-box-type__error d-block">
      * This field is required
    </mat-error>
  </div>
</div>

<ng-template #multiOptionTmpl>
  <lui-select-box-group
    class="confirmation-box-type__group"
    [formControl]="formControl"
    [required]="$any(props.required)"
  >
    <div class="mb-1 mb-md-0">
      <span class="confirmation-box-type__label">{{ props.label }}</span>
    </div>
    <div class="d-flex flex-column">
      <div class="d-flex">
        <lui-select-box
          *ngFor="let option of $any(props.options)"
          class="confirmation-box-type__box"
          [value]="option.value"
          [readonly]="props.readonly"
        >
          {{ option.label }}
        </lui-select-box>
      </div>
    </div>
  </lui-select-box-group>
</ng-template>
